import React, {useEffect} from 'react';
import Masonry from "react-masonry-css";
import LazyLoad from "react-lazyload";
import './Portfolio.css';

const Portfolio = () => {
  // Dynamically import all images from the folder
  const importAll = (r) => r.keys().map(r);
  const portfolioImages = importAll(
    require.context("../assets/images/portfolio", false, /\.(png|jpe?g|svg)$/)
  ).sort((a, b) => a.localeCompare(b)); // Sort by file name
  
  const breakpointColumnsObj = {
    default: 3, // 3 columns for large screens
    1100: 2,    // 2 columns for medium screens
    700: 1,     // 1 column for small screens
  };

  return (
    <section id="portfolio" className="portfolio">
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="portfolio-masonry"
        columnClassName="portfolio-column"
      >
        {portfolioImages.map((image, index) => (
          <div className="portfolio-item" key={index}>
            <LazyLoad height={200} offset={100} once>
              <img src={image} alt={`Portfolio ${index + 1}`} />
            </LazyLoad>
          </div>
        ))}
      </Masonry>
    </section>
  );
};

export default Portfolio;
